export default __webpack_public_path__ + "static/media/background-member-page.4d5887eb.png";